import axios from '../axios-marketplace';

const getCompras = (params) => axios.get('/fornecedor/compras', {
  params,
});

const getProdutosCompra = (id) => axios.get(`/fornecedor/compras/${id}/ofertas/todas`);

const getCompra = (id) => axios.get(`/fornecedor/compras/${id}`);

const cancelar = (id, data) => axios.put(`/fornecedor/compras/${id}/solicitar-revisao`, data);

const aprovar = (id, data) => axios.put(`/fornecedor/compras/${id}/aprovar`, data);

const aprovarValorFinal = (id, data) => axios.put(`/fornecedor/compras/${id}/aprovar-valor-final`, data);

const notificarMensagem = (id) => axios.post(`/notificacoes/compras/${id}`, {});

const getCobrancas = (id) => axios.get(`/compras/${id}/cobrancas`);

const getStatusFrete = (idPacote) => axios.get(`/fornecedor/pacotes/${idPacote}/fretes/status`);

const aprovarPacote = (idPacote, data) => axios.put(`/fornecedor/pacotes/${idPacote}/fretes/carrinho`, data);
const comprarPacote = (idPacote) => axios.put(`/fornecedor/pacotes/${idPacote}/fretes/comprar`, {});
const gerarEtiqueta = (idPacote) => axios.put(`/fornecedor/pacotes/${idPacote}/fretes/imprimir-etiqueta`, {});
const imprimirEtiqueta = (idPacote) => axios.put(`/fornecedor/pacotes/${idPacote}/fretes/preview-etiqueta`, {});
const cancelarFrete = (idPacote) => axios.put(`/fornecedor/pacotes/${idPacote}/fretes/cancelar`, {});

export default {
  getCompras,
  getProdutosCompra,
  getCompra,
  cancelar,
  aprovar,
  aprovarValorFinal,
  notificarMensagem,
  getCobrancas,
  getStatusFrete,
  aprovarPacote,
  comprarPacote,
  gerarEtiqueta,
  imprimirEtiqueta,
  cancelarFrete,
};
